import { useStore } from "@/store";
import { GeneralActionTypes } from "@/store/modules/general/action-types";
import { Roles } from "@/helpers/enums/Roles";
const store = useStore();
const selectedRole = localStorage.getItem("selectedRole");
const realRole = localStorage.getItem("realRole");
const data: any = {
    filter: {
        title: "filter",
        pageName: "filter",
        genre: "filter",
        ignoreSaveFilter: true,
        hideFilter: true,
        filters: [
        ],
    },
    header: {
       navigation: [
        
        ...(selectedRole !== Roles.PartnerAdmin
            ? [
                  {
                    title: "pdpLrpList",
                    url: "pdp-lrp-list",
                  },
              ]
            : []),

            ...(realRole === Roles.AGMSAdmin ||
                realRole === Roles.PartnerAdmin ||
                realRole === Roles.CompanyAdmin
                ? [
                      {
                          title: "pdpLrpSettings",
                          url: "pdp-lrp-settings",
                          active: true,
                      },
                  ]
                : [])
             
               
        ],
        buttonPosition: "justify-content-between",
        buttons: [],
    },
    modals: [
        {
            id: "exampleModalCenter",
            action: {
                label: "Save",
                function: function (arg: any) {
                    alert(JSON.stringify(arg));
                },
            },
            cancel: {
                label: "Close",
            },
            items: [
                {
                    title: "test",
                    options: [true],
                    filters: () => {
                        return data.readyToUseFilters;
                    },
                },
            ],
        },
    ],
    component: {
        type: "custom",
        options: {},
    },
};

export default data;
